// VLMAG public launch: September 26, 2026 at 12:00 PM ET (noon EDT = 16:00 UTC).
// Month is 0-indexed (8 = September).
export const LAUNCH_TS = Date.UTC(2026, 8, 26, 16, 0, 0);
export const LAUNCH_LABEL = "September 26, 2026 · 12PM ET";

// Manual override: when true, the site is LIVE immediately regardless of the
// countdown (root "/" serves the full site). The countdown page stays at /coming-soon.
export const FORCE_LIVE = true;

export const isLive = () => FORCE_LIVE || Date.now() >= LAUNCH_TS;
